import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from "react";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import VotingSettingBox, { getVotingSettingInputClasses } from "./VotingSettingBox";
export default function MaxVotesPerIdentityInput(t0) {
  const $ = _c(44);
  const {
    value,
    errors,
    onChange
  } = t0;
  let T0;
  let hasError;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== errors || $[1] !== onChange || $[2] !== value) {
    hasError = errors.includes(CREATE_WAVE_VALIDATION_ERROR.MAX_VOTES_PER_IDENTITY_PER_DROP_INVALID);
    const hasValue = value !== null && Number.isFinite(value);
    let t16;
    if ($[20] !== onChange) {
      t16 = e => {
        const rawValue = e.target.value.trim();
        if (!rawValue) {
          onChange(null);
          return;
        }
        onChange(Number(rawValue));
      };
      $[20] = onChange;
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    const onInputChange = t16;
    T0 = VotingSettingBox;
    t9 = "max-votes-per-identity-per-drop-error";
    t10 = "Enter a whole number greater than 0.";
    t11 = hasError;
    t12 = "max-votes-per-identity-per-drop-help";
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <>Optional. Leave blank to use each identity's full voting power. Set 1 for one identity = one vote.</>;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    t14 = "max-votes-per-identity-per-drop";
    t15 = "Vote cap per identity";
    t1 = "number";
    t2 = 1;
    t3 = 1;
    t4 = hasValue ? value.toString() : "";
    t5 = onInputChange;
    t6 = "max-votes-per-identity-per-drop";
    t7 = "off";
    t8 = getVotingSettingInputClasses({
      hasError,
      hasValue
    });
    $[0] = errors;
    $[1] = onChange;
    $[2] = value;
    $[3] = T0;
    $[4] = hasError;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t14;
    $[11] = t15;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[3];
    hasError = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t14 = $[10];
    t15 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  const t16 = hasError ? "max-votes-per-identity-per-drop-error max-votes-per-identity-per-drop-help" : "max-votes-per-identity-per-drop-help";
  let t17;
  if ($[23] !== hasError || $[24] !== t1 || $[25] !== t16 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8) {
    t17 = <input type={t1} min={t2} step={t3} value={t4} onChange={t5} id={t6} autoComplete={t7} className={t8} aria-invalid={hasError} aria-describedby={t16} />;
    $[23] = hasError;
    $[24] = t1;
    $[25] = t16;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== T0 || $[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t15 || $[41] !== t17 || $[42] !== t9) {
    t18 = <T0 errorId={t9} errorMessage={t10} hasError={t11} helpId={t12} helpText={t13} inputId={t14} label={t15}>{t17}</T0>;
    $[34] = T0;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
    $[41] = t17;
    $[42] = t9;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}